module.exports = __webpack_public_path__ + "static/img/gs-logo.9a29e78a.png";